const projects = [
  {
    image: "assets/images/codechef.png",
    tag: "Competitive Programming",
    title: "CodeChef Profile",
    href: "https://www.codechef.com/users/aziztamim",
    description:
      "Actively solving problems on CodeChef for 6+ months. Achieved a maximum rating of 1637 and earned a 3-star badge through consistent contest participation and strategic problem selection.",
    ctaLabel: "View Profile →",
  },
  {
    image: "assets/images/codeforces.png",
    tag: "Competitive Programming",
    title: "Codeforces Profile",
    href: "https://codeforces.com/profile/AbdulAzizTamim",
    description:
      "Solved 400+ problems on Codeforces over a year of regular practice. Reached Pupil rating (1199) with a focus on improving algorithmic thinking, time complexity analysis, and competitive speed.",
    ctaLabel: "View Profile →",
  },
  {
    image: "assets/images/cpi-website.png",
    tag: "Web Development",
    title: "Compact Polytechnic Institute",
    href: "https://cpifeni.vercel.app/",
    description:
      "Semester project — developed the official website for my institute. Features detailed college information, curriculum pages, activity updates, and a clean responsive layout. Completed in one month.",
    ctaLabel: "Visit Site →",
  },
];

const Projects = () => {
  return (
    <section className="projects section-padding" id="projects">
      <div className="container">
        {/* Section header */}
        <div
          className="text-center section-header"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <span className="sec-label">Portfolio</span>
          <h2 className="sec-title">Selected Work</h2>
          <div className="sec-line" />
        </div>

        <div className="projects__grid">
          {projects.map((proj, idx) => (
            <div
              key={proj.title}
              className="projects__card"
              data-aos="fade-up"
              data-aos-duration="700"
              data-aos-delay={idx * 120}
            >
              <div className="projects__card-image">
                <img src={proj.image} alt={proj.title} />
                <div className="projects__card-overlay">
                  <a
                    href={proj.href}
                    target="_blank"
                    rel="noreferrer"
                    className="projects__card-overlay-btn"
                  >
                    {proj.ctaLabel}
                  </a>
                </div>
              </div>
              <div className="projects__card-content">
                <span className="projects__card-tag">{proj.tag}</span>
                <h3 className="projects__card-title">
                  <a href={proj.href} target="_blank" rel="noreferrer">
                    {proj.title}
                  </a>
                </h3>
                <p className="projects__card-body">{proj.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
